var map = {
	"./tasks/reports/varieties-yearly/routes.children.js": 3074,
	"./tasks/reports/varieties/routes.children.js": 9674,
	"./tasks/research/crop_sales_team/routes.children.js": 7329,
	"./tasks/setup/competitors/routes.children.js": 9859,
	"./tasks/setup/crop-features/routes.children.js": 6344,
	"./tasks/setup/crop-types/routes.children.js": 9511,
	"./tasks/setup/crop-types2/routes.children.js": 5655,
	"./tasks/setup/crops/routes.children.js": 5408,
	"./tasks/setup/diseases/routes.children.js": 418,
	"./tasks/setup/location_areas/routes.children.js": 2023,
	"./tasks/setup/location_parts/routes.children.js": 2062,
	"./tasks/setup/location_territories/routes.children.js": 8356,
	"./tasks/setup/principals/routes.children.js": 6605,
	"./tasks/setup/research_pictures/routes.children.js": 2603,
	"./tasks/setup/seasons/routes.children.js": 566,
	"./tasks/setup/trial-stations/routes.children.js": 4688,
	"./tasks/setup/varieties/routes.children.js": 493,
	"./tasks/setup/varieties2/routes.children.js": 5886,
	"./tasks/system/configurations/routes.children.js": 9600,
	"./tasks/system/module-tasks/routes.children.js": 689,
	"./tasks/system/user-groups/routes.children.js": 6228,
	"./tasks/system/user-types/routes.children.js": 5860,
	"./tasks/trial/data/routes.children.js": 8102,
	"./tasks/trial/forms/routes.children.js": 8963,
	"./tasks/trial/report-data/routes.children.js": 5389,
	"./tasks/trial/report-forms/routes.children.js": 5551,
	"./tasks/users/routes.children.js": 7098,
	"./tasks/variety-configuration/delivery/routes.children.js": 9325,
	"./tasks/variety-configuration/selection/routes.children.js": 592,
	"./tasks/variety-configuration/sowing/routes.children.js": 3805
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9196;